module.exports = __webpack_public_path__ + "img/hartkirchen.0fc4a6ed.jpg";